<template>
  <BaseModal v-model="show" title="修图照片同步设置" :width="540" :centered="true">
    <FormModel :action="submit" :model="form" :rules="rules" button-title="确认开始">
      <a-form-model-item label="摄影师" prop="grapherId">
        <AlbumGrapher ref="grapher" v-model="form.grapherId" :album-id="album.id" empty-text="All / 全部摄影师"/>
      </a-form-model-item>
      <a-form-model-item label="下载保存目录" prop="downloadDir">
        <FolderPicker v-model="form.downloadDir" :sub-dir="album.info.name"
                      @ready="syncExport" @change="syncExport" placeholder="点击选择图片下载保存目录" :state-key="stateKey"/>
        <div class="hint">
          <a-icon type="info-circle"/>
          系统将自动在您选择的目录下创建以 <b>相册名</b> 命名的子文件夹，并下载图片保存到该目录
        </div>
      </a-form-model-item>
      <a-form-model-item label="回传保存目录" prop="exportDir">
        <a-input v-model="form.exportDir" readOnly/>
        <div class="hint">
          <a-icon type="info-circle"/>
          下载目录下创建了 <b>upload</b> 子文件夹，将已修图片导出到该目录，系统会自动检测并上传
        </div>
      </a-form-model-item>
    </FormModel>
  </BaseModal>
</template>

<script>
import func from "../../../../../utils/func";
import BaseModal from "../../../../../comps/BaseModal";
import FormModel from "../../../../../comps/FormModel";
import FolderPicker from "../../../../../comps/FolderPicker";
import AlbumGrapher from "../../comps/AlbumGrapher";

export default {
  name: "RetouchForm",
  props: {album: Object},
  components: {AlbumGrapher, FolderPicker, FormModel, BaseModal},
  data() {
    return {
      show: false,
      form: {
        grapherId: "all", // 摄影师
        downloadDir: "", // 下载目录
        exportDir: "", // 导出目录
      },
      rules: {
        grapherId: {required: true, message: "请选择摄影师"},
        downloadDir: {required: true, message: "请选择图片下载保存目录"},
        exportDir: {required: true, message: "请选择图片回传保存目录"},
      },
    }
  },
  computed: {
    stateKey() {
      return `retouch.download.dir.${this.album.id}`;
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    async submit() {
      this.show = false;
      const args = func.copyObject(this.form);
      if (args.grapherId === "all") {
        args.grapherId = "";
      }
      this.$emit("start", args);
    },
    syncExport(dir) {
      this.form.exportDir = dir ? `${dir}/upload` : '';
    }
  }
}
</script>

<style scoped>
.hint {
  color: red;
  font-size: 12px;
}
</style>